import { render } from "./Highlight.vue?vue&type=template&id=55f00cfe"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Highlight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55f00cfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55f00cfe', __exports__)) {
    api.reload('55f00cfe', __exports__)
  }
  
  module.hot.accept("./Highlight.vue?vue&type=template&id=55f00cfe", () => {
    api.rerender('55f00cfe', render)
  })

}


export default __exports__